<template>
  <div class="form-group" :class="label ? 'labelled' : ''">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="soft-select-wrapper">
      <select
        :id="id"
        class="form-control soft-select-control"
        :placeholder="placeholder"
        :value="modelValue"
        :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option selected value="" v-if="placeholder!=''">{{ placeholder }}</option>
        <option v-for="valor in valores" :key="valor.id" :value="valor.id">{{ valor.nombre }}</option>
      </select>
      <span class="soft-select-arrow" aria-hidden="true"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftSelect",
  props: {
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Seleccione...",
    },
    name: {
      type: String,
      default: "",
    },
    valores: {
      type: Array,
    },
    modelValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  methods: {
    handleSelectChange(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>

<style scoped>
.soft-select-wrapper {
  position: relative;
}

.soft-select-control {
  appearance: none;
  padding-right: 2.5rem;
}

.soft-select-arrow {
  position: absolute;
  top: 50%;
  right: 1rem;
  width: 0.65rem;
  height: 0.65rem;
  border-right: 2px solid #8392ab;
  border-bottom: 2px solid #8392ab;
  pointer-events: none;
  transform: translateY(-70%) rotate(45deg);
}

.soft-select-control:disabled + .soft-select-arrow {
  opacity: 0.5;
}
</style>
